import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {AbstractBffApi} from '../../models/sharedinterface';
import {ApiFactoryService} from '../../shared/services/api-factory.service';

@Component({
  selector: 'app-passwordforgotview',
  templateUrl: './passwordforgotview.component.html',
  styleUrls: ['./passwordforgotview.component.scss']
})
export class PasswordforgotviewComponent implements OnInit {

  recoveryForm: UntypedFormGroup;
  submitted: boolean;

  public error: string;
  public errorUsernameOrEmail: string;

  bffapi: AbstractBffApi;

  constructor(private fb: UntypedFormBuilder, private apifactory: ApiFactoryService) {
    this.recoveryForm = new UntypedFormGroup({});
    this.bffapi = this.apifactory.createBffApi();
  }

  ngOnInit(): void {
    this.submitted = false;
    this.recoveryForm = this.fb.group({
      usernameOrEmail: ['', Validators.required]
    });
  }

  onSubmitRecoveryForm() {

    if (this.recoveryForm.valid) {

      const query = this.bffapi.requestPasswordReset(this.recoveryForm.value.usernameOrEmail);
      query.subscribe((data) => {
          console.log(data);
        },
        error => {
          if (error.status === 0) {// Unknown error - service not responding
            this.error = 'Network error. Please try again later.';
          } else if (error.status === 400) {// Bad request - should never happen cause there is a validator on the service)
            this.error = 'System error. Please try again later.';
          }
        });

      this.submitted = true;

    } else {

      this.errorUsernameOrEmail = 'This field is required.';

    }
  }

}
